import { round, trim } from './utils';
class DomUtils {
    static css(el, list) {
        for (const k in list) {
            const property = DomUtils.format(k);
            if (!list[k])
                el.style.removeProperty(property);
            else
                el.style.setProperty(property, list[k]);
        }
    }
    static height(el) {
        return round((el === null || el === void 0 ? void 0 : el.getBoundingClientRect().height) || 0);
    }
    static style(el, names) {
        return names.map(it => {
            const name = DomUtils.format(it);
            return window.getComputedStyle(el).getPropertyValue(name);
        });
    }
    static format(str) {
        const f = (m) => '-' + m.toLowerCase();
        return trim(str.replace(/[A-Z]/g, f), '-');
    }
}
export default DomUtils;
